var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsychiatryCouch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-2{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108,64.75H61.74c-11.33,0-22.33,9.56-22.33,21.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "109.73 64.75 110.53 64.75 106.53 64.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.45,64.75h46.22C168,64.75,179,74.31,179,86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.45,144.7H47A8.69,8.69,0,0,1,38.4,136l-3.51-30.09s-11.14.4-10.16-9.78c0-5.69,5.63-10.3,12.57-10.3s11.24,4.24,12.56,10.3l2.42,21.4c0,4.77,3.14,8.69,7,8.69h51.63m-.43,18.48h61.24a8.69,8.69,0,0,0,8.63-8.7l3.51-30.09s11.13.4,10.15-9.78c0-5.69-5.62-10.3-12.56-10.3s-11.25,4.24-12.57,10.3l-2.41,21.4c0,4.77-3.14,8.69-7,8.69h-49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54,154.68H50.11A2.7,2.7,0,0,1,47.42,152l-1.85-7.1c0-1.48,3.06-2.69,4.54-2.69H54c1.47,0,4.53,1.21,4.53,2.69L56.66,152A2.7,2.7,0,0,1,54,154.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.61,154.68h-3.86a2.7,2.7,0,0,1-2.69-2.68l-1.85-7.1c0-1.48,3.06-2.69,4.54-2.69h3.86c1.47,0,4.53,1.21,4.53,2.69L171.3,152a2.7,2.7,0,0,1-2.69,2.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.16,122.2c12.39-4.78,32.66-7.88,55.56-7.88s43.16,3.1,55.55,7.88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychiatryCouch);
export default __webpack_public_path__ + "static/media/PSYCHIATRY_COUCH.723593f23faaf11f13be193cbea63afb.svg";
export { ForwardRef as ReactComponent };